import { useState } from "react";
import { MathShell, ResultCard, MATH_ACCENT } from "./MathShell.jsx";
import { evaluate, round } from "./mathcore.js";

const KEYS = [
  ["sin(", "cos(", "tan(", "^"],
  ["ln(", "log(", "sqrt(", "!"],
  ["7", "8", "9", "/"],
  ["4", "5", "6", "*"],
  ["1", "2", "3", "-"],
  ["0", ".", "(", "+"],
  [")", "pi", "e", "C"],
];

export default function Calculator() {
  const [expr, setExpr] = useState("");
  const [out, setOut] = useState(null);

  const press = (k) => {
    if (k === "C") { setExpr(""); setOut(null); return; }
    setExpr((e) => e + k);
  };
  const calc = () => {
    const r = evaluate(expr);
    setOut(r.ok ? { val: round(r.result, 10) } : { err: r.error });
  };

  return (
    <MathShell title="Scientific Calculator">
      <div
        style={{
          background: "#13141F",
          border: "1px solid #262839",
          borderRadius: 12,
          padding: "16px 18px",
          minHeight: 64,
          marginBottom: 14,
          fontSize: 18,
          wordBreak: "break-all",
        }}
      >
        <div style={{ color: "#9A9DBE", fontSize: 14, minHeight: 18 }}>{expr || "Enter an expression"}</div>
        {out && (
          <div style={{ marginTop: 8, fontWeight: 700, color: out.err ? "#F8716A" : MATH_ACCENT }}>
            {out.err ? out.err : `= ${out.val}`}
          </div>
        )}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
        {KEYS.flat().map((k) => (
          <button
            key={k}
            onClick={() => press(k)}
            style={{
              background: k === "C" ? "#2A1518" : "#1C1E2E",
              color: k === "C" ? "#F8716A" : "#E8E9F3",
              border: "none",
              borderRadius: 10,
              padding: "16px 0",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            {k}
          </button>
        ))}
      </div>
      <button
        onClick={calc}
        style={{
          marginTop: 12,
          width: "100%",
          background: MATH_ACCENT,
          color: "#06201C",
          fontWeight: 700,
          fontSize: 17,
          border: "none",
          borderRadius: 12,
          padding: "15px 0",
          cursor: "pointer",
        }}
      >
        =
      </button>
      <p style={{ fontSize: 12, color: "#5B5E7A", marginTop: 14 }}>
        Trig functions use radians. Use pi and e as constants.
      </p>
    </MathShell>
  );
}

